import { render, staticRenderFns } from "./PeriodicReview.vue?vue&type=template&id=1571d9c6&"
import script from "./PeriodicReview.vue?vue&type=script&lang=js&"
export * from "./PeriodicReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports